
    <mat-card-header>
      <mat-toolbar class="toolbar">
        <mat-card-title style="font-size: 20px; font-weight: bold; font-family: 'Times New Roman', Times, serif;">{{ 'listpassager' | translate }}</mat-card-title>
        <span class="toolbar-spacer"></span>
        <button mat-mini-fab color="primary" title="Panier" [matBadge]="card?.length" matBadgePosition="after" matBadgeColor="warn" (click)="opencard()"><mat-icon>crop_free</mat-icon></button>


      </mat-toolbar>
    </mat-card-header>

    <!-- <div class="row"> -->
        <div class="container">
          <mat-form-field>
              <input matInput #searchInput (keyup)="applyFilter($event.target.value)" placeholder="{{ 'search_users_placeholder' | translate }}">
          </mat-form-field>
          <div class="mat-elevation-z8">
              <table mat-table [dataSource]="dataSource" matSort>

                  <!-- ID Column -->
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
                    <td mat-cell *matCellDef="let element; let i=index;"> {{i+1}} </td>
                  </ng-container>

                  <!-- Name Column -->
                  <ng-container matColumnDef="numero">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'numero' | translate}} </th>
                      <td mat-cell *matCellDef="let row"> {{row.idpassager}} </td>
                  </ng-container>

                  <ng-container matColumnDef="nom">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'table_headers.name' | translate}}(#{{'passager'| translate}}) </th>
                    <td mat-cell *matCellDef="let row"> {{row.nompassager}} ({{row.numticket}})</td>
                </ng-container>

                <ng-container matColumnDef="contact">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'table_headers.phone' | translate}} </th>
                  <td mat-cell *matCellDef="let row"> {{row.contact}} </td>
              </ng-container>

              <ng-container matColumnDef="cni">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'form_fields.idcardnumber' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.cni}} </td>
            </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'action' | translate}} </th>
                  <td mat-cell *matCellDef="let element">
                      <ng-container *ngIf="userprivileges[6].state">
                        <a (click)="editPassenger(element)" class="accent"><i style="color: rgb(9, 11, 121);" class="material-icons">edit</i></a>
                      </ng-container>
                      <ng-container *ngIf="userprivileges[6].state">
                        <a (click)="printPassengerTrip(element)" class="accent"><i style="color: rgb(9, 11, 121);" class="material-icons">print</i></a>
                      </ng-container>
                      <ng-container *ngIf="userprivileges[7].state">
                        <a (click)="delete(element)" title="supprimer"><i style="color: darkred;" class="material-icons">delete</i></a>
                      </ng-container>
                  </td>
              </ng-container>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                  No records found.
                </td>
              </tr>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr class="example-element-row" mat-row *matRowDef="let row; columns: displayedColumns;" (dblclick)="viewPassengerTrip(row)"></tr>
              </table>

              <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 100,passengerlist?.totalElements]" (page)="nextPage($event)" [length]="passengerlist?.totalElements"
              showFirstLastButtons></mat-paginator>
            </div>
      </div>
